/**
 * Created by adalto on 11/17/14.
 */

import ActualRouteLayer from 'react/components/RouteDetails/ActualRouteLayer';
import { CustomProvider, renderComponent } from 'react/utils/renderUtils';


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.MapLayerActions = Greenmile.Toolbar.MapLayerActions || {};

Greenmile.Toolbar.MapLayerActions.LayerActualRouteWithMultiRoute = (function () {

    function LayerActualRouteWithMultiRoute (routeId) {
        Greenmile.Toolbar.MapLayerActions.LayerActualRoute.apply(this, arguments);

        this.LAYER_NAME = 'actual_route';
        this.RESOURCE_LAYER = 'RouteDetail.ToolBar.Layers.ActualRoute';

        this.render = function () {
            const sourceScreen = Monet.Session.RouteDetail.screensList[routeId];
            const itemList = document.createElement('li');
            
            renderComponent(
                <CustomProvider>
                    <ActualRouteLayer sourceScreen={sourceScreen} context={this} />
                </CustomProvider>,
                itemList
            );

            return itemList;
        };
    }

    return LayerActualRouteWithMultiRoute;
})();
